import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ProductCategoryListView } from "./product-category-list.view";
import { ProductCategoryListDataService } from "./product-category-list.data";

export class ProductCategoryListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: ProductCategoryListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = ProductCategoryListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: ProductCategorySummary) {
        this.props.history.push(`/products/categories/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <ProductCategoryListView
            model={this.dataService}
            setBusy={this.props.setBusy}
            onItemDoubleClicked={this.onItemDoubleClicked}
            {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/list/product-category-list.controller.tsx